import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { SliderInput, Space, Typography } from '@sravni/react-design-system';
import { Controller } from 'react-hook-form';

import { usePeriodInfo } from '../lib/usePeriodInfo';

const { Text } = Typography;

export const Period = (props: IFieldFactoryProps) => {
  const { type, label, ...other } = props;

  const { maxPeriod, minPeriod, duration, postfix } = usePeriodInfo();

  return (
    <Space
      size={4}
      direction="vertical"
    >
      <Controller
        name={type}
        {...other}
        render={({ field }) => (
          <SliderInput
            label={label}
            name={type}
            min={minPeriod}
            max={maxPeriod}
            postfix={postfix}
            value={Number(field.value)}
            onChange={field.onChange}
          />
        )}
      />
      <Text
        size={12}
        className="h-color-D60 h-ml-16"
      >
        от {minPeriod} до {maxPeriod} {duration}
      </Text>
    </Space>
  );
};
